import React from "react";
import {ConnectedRouter} from "connected-react-router";
import {Provider} from "react-redux";
import {Route, Switch} from "react-router-dom";

import {ApolloProvider} from 'react-apollo'
import {Rehydrated} from 'aws-appsync-react'
import {client} from "apollo/client";

import "assets/vendors/style";
import "styles/wieldy.less";
import configureStore, {history} from "./appRedux/store";
import "./firebase/firebase";
import App from "./containers/App/index";
import HTML5Backend from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import ScrollToTop from './ScrollToTop'

export const store = configureStore();
// const customContext = React.createContext(null) // your own context

const NextApp = () =>
  <Provider store={store}>
    <ApolloProvider client={client}>
        <DndProvider backend={HTML5Backend}>
          <ConnectedRouter history={history}>
            <ScrollToTop>
               <Switch>
                <Route path="/" component={App}/>
              </Switch>
            </ScrollToTop>
          </ConnectedRouter>
        </DndProvider>
    </ApolloProvider>
  </Provider>;


export default NextApp;
